export function convertMillisecondsToHoursAndMinutes(milliseconds: number) {
  // Calculate total hours
  const hours = Math.floor(milliseconds / 3600000);
  // Calculate minutes from the remainder
  const minutes = Math.floor((milliseconds % 3600000) / 60000);

  return `${hours} h ${minutes} m`;
}
